/* eslint-disable no-unused-vars */
import { Fragment, useMemo } from 'react';

import TaskDetailComponent from '@components/task-detail-component';
import Icon from '@components/icon-component';

import { PERMISSIONS } from 'permissions/constants';
import { decodeToken } from '@utilities/authentication';
import style from './style.module.scss';

const Pipeline = ({
  setAllTask,
  setWorkOrder,
  setChecks,
  setInspections,
  allWorkOrder = [],
  allDoneWorkOrder = [],
  allInspection = [],
  allDoneInspection = [],
  allTasks = [],
  allDoneTasks = [],
  isOverDue,
  isWorkOrderOverDue,
  isInspectionOverDue,
  allChecks = [],
  allDoneCheck = [],
  isCheckOverDue,
  newWorkRequestList,
  setWorkRequest,
  allOnDemandRecordCount,
  newWorkOrderList,
  newChecksList,
  newInspectionList,
  card: Card = () => <></>
}) => {
  const { iconName, taskName } = useMemo(() => {
    let showAllTasksAndRecordsTab = false,
      showAllTasksTab = false,
      showAllRecordTab = false,
      iconName = '',
      taskName = '';

    (showAllTasksAndRecordsTab = allOnDemandRecordCount > 0 && allTasks?.length > 0 ? true : false),
      (showAllTasksTab = allOnDemandRecordCount === 0 && allTasks?.length > 0 ? true : false),
      (showAllRecordTab = allOnDemandRecordCount > 0 && allTasks?.length === 0 ? true : false);

    if (showAllRecordTab) iconName = 'on-demand-indicator-circle';
    else if (showAllTasksTab) {
      iconName =
        allDoneTasks?.length === allTasks?.length
          ? 'all-task-completed-bag'
          : allDoneTasks?.length > 0 && allTasks?.length > allDoneTasks?.length
          ? 'some-task-completed-bag'
          : 'no-task-completed-bag';
    } else if (showAllTasksAndRecordsTab) {
      iconName =
        allDoneTasks?.length === allTasks?.length
          ? 'task-record-all-task-completed'
          : allDoneTasks?.length > 0 && allTasks?.length > allDoneTasks?.length
          ? 'task-record-some-task-completed'
          : 'task-record-no-task-completed';
    }

    taskName = showAllTasksAndRecordsTab
      ? 'All tasks + records'
      : showAllTasksTab
      ? 'All tasks'
      : showAllRecordTab
      ? 'All records'
      : '';

    return {
      iconName,
      taskName
    };
  }, [allOnDemandRecordCount, allTasks]);

  const allTasksAndRecordsChips = {
    img: <Icon name={iconName} />,
    taskName: taskName,
    btnText: `${allDoneTasks.length}/${allTasks.length}`,
    click: () => setAllTask(true),
    allDoneTasks: allDoneTasks,
    allTasksForSite: allTasks,
    isOverDue: isOverDue,
    dot: !!isOverDue && allDoneTasks?.length !== allTasks?.length,
    recordCount: allOnDemandRecordCount,
    notShowInProgressCount: allDoneTasks?.length > 0 || allTasks.length > 0 ? false : true
  };

  const taskDetail = [
    {
      img: <Icon name={'ins'} />,
      taskName: 'Inspections',
      btnText: `${allDoneInspection?.length}/${allInspection?.length}`,
      click: () => setInspections(true),
      allDoneTasks: allDoneInspection,
      allTasks: allInspection,
      isOverDue: isInspectionOverDue,
      dot: !!isInspectionOverDue && allDoneInspection?.length !== allInspection?.length,
      recordCount: newInspectionList?.length || 0,
      notShowInProgressCount:
        allDoneInspection?.length > 0 || allInspection.length > 0 ? false : true
    },
    {
      img: <Icon name={'work-orders'} />,
      taskName: 'Work orders',
      btnText: `${allDoneWorkOrder?.length}/${allWorkOrder?.length}`,
      click: () => setWorkOrder(true),
      allDoneTasks: allDoneWorkOrder,
      allTasks: allWorkOrder,
      isOverDue: isWorkOrderOverDue,
      dot: !!isWorkOrderOverDue && allDoneWorkOrder?.length !== allWorkOrder?.length,
      recordCount: newWorkOrderList?.length || 0,
      notShowInProgressCount: allDoneWorkOrder?.length > 0 || allWorkOrder.length > 0 ? false : true
    },
    {
      img: <Icon name={'check-grey'} />,
      taskName: 'Checks',
      btnText: `${allDoneCheck?.length}/${allChecks?.length}`,
      click: () => setChecks(true),
      allDoneTasks: allDoneCheck,
      allTasks: allChecks,
      isOverDue: isCheckOverDue,
      dot: !!isCheckOverDue && allDoneCheck?.length !== allChecks?.length,
      recordCount: newChecksList?.length || 0,
      notShowInProgressCount: allDoneCheck?.length > 0 || allChecks.length > 0 ? false : true
    },
    {
      img: <Icon name={'work-orders'} />,
      taskName: 'Work requests',
      btnText: `${newWorkRequestList?.length}`,
      click: () => setWorkRequest(true),
      allDoneTasks: [],
      allTasks: newWorkRequestList,
      isOverDue: false,
      dot: false,
      notShowInProgressCount: false
    }
  ];

  return (
    <div id="tasks-info-tab" style={{ overflow: 'auto' }} className={style.testing}>
      {Card ? <Card /> : <></>}

      <div className={style.allTasksAndRecordsContainer}>
        <TaskDetailComponent
          task={allTasksAndRecordsChips.taskName}
          onClick={allTasksAndRecordsChips.click}
          {...allTasksAndRecordsChips}
        />

        <div className={style.byType}>
          <p>By type</p>
        </div>
      </div>
      <div className={style.addMarginBottom}>
        {(allTasks?.length > 0 || newWorkRequestList?.length > 0 || allOnDemandRecordCount > 0) &&
          taskDetail
            ?.filter(({ taskName }) => {
              const permissions = decodeToken()?.permissions || {};
              if (taskName === 'Checks' && !permissions[PERMISSIONS.MOBILE_ASSIGNED_CHECKS])
                return false;
              if (
                taskName === 'Inspections' &&
                !permissions[PERMISSIONS.MOBILE_ASSIGNED_INSPECTIONS]
              )
                return false;
              if (
                taskName === 'Work orders' &&
                !permissions[PERMISSIONS.MOBILE_ASSIGNED_WORKORDERS]
              )
                return false;
              if (
                taskName === 'Work requests' &&
                !permissions[PERMISSIONS.MOBILE_ASSIGNED_WORKORDERS]
              )
                return false;
              return true;
            })
            .filter((a) => a?.allTasks?.length > 0 || a?.recordCount > 0)
            .map((ele, index) => {
              return ele.taskName === 'All Tasks' &&
                taskDetail?.filter((a) => a.allTasks.length > 0).length === 2 ? (
                <Fragment key={index}></Fragment>
              ) : (
                <TaskDetailComponent
                  key={index}
                  task={ele.taskName}
                  onClick={ele.click}
                  isOverDue={isOverDue}
                  allTasksForSite={ele.allTasks}
                  showBorderOnTop={!index}
                  {...ele}
                />
              );
            })}
      </div>
    </div>
  );
};

export default Pipeline;
